$('.items').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        slidesToShow: 2,
      }
    },
  ]
});
    
// footer menu js
    
var w=$(window).width();
if (w < 746 ){
$(".footer__title").click(function(){
       $(this).siblings('ul.footer__menu').toggle();
       $( this ).toggleClass( "active" );
 });
  
$(".footer__title").click(function(){
       $(this).siblings('.footer__newsletter').toggle();
 });
}



$('.cart-recommendations1').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        slidesToShow: 2,
      }
    },
  ]
});
$('body').click(function (event) 
{  
  if(!$(event.target).closest('.product-image-main').length && !$(event.target).is('.product-image-main')){
    if(!$(event.target).closest('.pswp__scroll-wrap').length && !$(event.target).is('.pswp__scroll-wrap')) {
     console.log($('.pswp').is(':visible'))
     if($('.pswp').is(':visible')){
         $('.pswp__button--close').trigger('click');       
     }
   }
  }else {
//     $('.pswp').hide();
  }
});
$(function() {
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    $('body').addClass('safari-mac');
  }
});

function goBack() {
  window.history.back();
}
$('.has-child-submenu').click( function() {
  console.log($(this))
     if($(this).hasClass("main-active")){
   		$(this).toggleClass("main-active"); // adding active class
       return true;
     }else{
      $(this).addClass("main-active"); // adding active class
     }
  return false;
});
$(".has-submenu").click(function() {
  console.log($(this),'main')
   		$(this).toggleClass("main-active"); // adding active class
});

// hide collection title div for mobile

if ($(window).width() < 768) {
  $('.template-collection .title-with-sort-by .page-content.page-content--top').remove();
}
// hide collection title div for Desktop
if ($(window).width() > 768) {
  $('.template-collection .main-content>div#shopify-section-collection-header').remove();
}

// read more js

 $(document).ready(function () {
      $('.enlarge-text').readall({
          // Default values
          showheight: 260,                         // height to show
          showrows: null,                         // rows to show (overrides showheight)
          animationspeed: 200,                    // speed of transition
          btnTextShowmore: 'Read more',           // text shown on button to show more
          btnTextShowless: 'Read less',           // text shown on button to show less
          btnClassShowmore: 'readall-button',     // class(es) on button to show more
          btnClassShowless: 'readall-button'      // class(es) on button to show less
      });
});



